import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Button } from "react-bootstrap";
import FolderIcon from "react-ionicons/lib/Folder";
import UserAnalytic from '../../helpers/UserAnalytic';

export const DFLT_ICO_PROPS = {
    height: '32px',
    width:  '32px',
    color: 'inherit',
    className: 'type-ico'
};

const DocumentPermission = ({
    user, permissions,
    handleUpdateUserDrivePermission
}) => {
    // {'ar': 7}
    const [ formData, setFormData ] = useState({});
    const handleSelectValue = (key, value) => {
        setFormData({
            ...formData,
            [key]: value
        });
    };
    const handleUpdateBtn = (e) => {
        if (e) {
            e.target.blur();
        }
        UserAnalytic.event({
            category: 'Doc Permission',
            action: 'Update Doc Permission',
        });
        const permissions = Object.keys(formData).map(key => ({
            code: key,
            securityLevel: Number(formData[key])
        }));
        handleUpdateUserDrivePermission(permissions);
    };
    useEffect(() => {
        const newPerm = permissions.reduce((memo, elm) => ({
            ...memo,
            [elm.code]: elm.securityLevel
        }), {});
        setFormData(newPerm);
    }, [permissions]);
    return (
        <>
            <Row>
                <Col>
                    <Button variant="primary" onClick={handleUpdateBtn} >Save</Button>
                </Col>
            </Row>
            {(permissions || []).map((item, idx) => (
                <Row key={idx} className="permission-field g-0 pt-2 pb-2">
                    <Col
                        className="fw-bold p-2"
                        lg={10}
                        md={12}
                    >
                        <span className='me-2' style={{
                            color: 'var(--main-brand-color)',
                            fill: 'var(--main-brand-color)'
                        }}>
                            <FolderIcon {...DFLT_ICO_PROPS} />
                        </span>
                        {item.label}
                    </Col>
                    <Col lg={2} md={4}>
                        <Form.Select
                            disabled={user.isBusinessOwner}
                            onChange={(e) => handleSelectValue(item.code, e.target.value)}
                            value={formData[item.code]}>
                            <option value={0}>No</option>
                            <option value={7}>Yes</option>
                        </Form.Select>
                    </Col>
                </Row>
            ))}
        </>
    );
};

export default DocumentPermission;